const FENCED_BLOCK = /```[a-zA-Z0-9_-]*\n?([\s\S]*?)```/g
const PRE_TAG = /<\/?pre\b[^>]*>/gi
const CODE_TAG = /<\/?code\b[^>]*>/gi
const INDENTED_CODE_BLOCK_LEADER = /^[ \t]{4,}/gm

export function stripCodeBlocks(text: string): string {
  return text
    .replace(FENCED_BLOCK, (_match, inner: string) => inner.trimEnd())
    .replace(PRE_TAG, '')
    .replace(CODE_TAG, '')
    .replace(INDENTED_CODE_BLOCK_LEADER, '')
}
